import request from '@/router/axios'
import env from '@/config/env'

// 获取分页
export const pageApi = (params) => {
  return request({
    url: env.ferryUrl + '/express/order/page',
    method: 'POST',
    data: params
  })
}
// 订单详情
export const fetchOrderInfo = (id) => {
  return request({
    url: env.ferryUrl + `/express/order/info/${id}`,
    method: 'get'
  })
}
// 退款订单详情
export const refundOrderDetail = (id) => {
  return request({
    url: env.ferryUrl + `/express/order/refund/order-detail/${id}`,
    method: 'get'
  })
}

// 申请退款
export const refundApply = (params) => {
  return request({
    url: env.ferryUrl + '/express/order/refund/apply',
    method: 'post',
    data: params
  })
}
// 改签订单详情接口
export const changeOrderInfo = (params) => {
  return request({
    url: env.ferryUrl + '/express/order/change-order-info',
    method: 'post',
    data: params
  })
}
// 改签订单
export const orderChange = (params) => {
  return request({
    url: env.ferryUrl + '/express/order/order/change',
    method: 'post',
    data: params
  })
}

// 结束订单
export const orderFinished = (id) => {
  return request({
    url: env.ferryUrl + `/express/order/finished/${id}`,
    method: 'get'
  })
}

// 结束订单
export const orderLog = (orderId) => {
  return request({
    url: env.ferryUrl + `/express/order/log/${orderId}`,
    method: 'get'
  })
}

// 修改联系人
export const changeContact = (params) => {
  return request({
    url: env.ferryUrl + '/express/order/change-contact',
    method: 'post',
    data: params
  })
}
// 后台备注
export const sysRemark = (params) => {
  return request({
    url: env.ferryUrl + '/express/order/sys-remark',
    method: 'post',
    data: params
  })
}
